import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '@/components/base/SEO';

const CONTACT_FORM_URL = 'https://readdy.ai/api/form/d9pbtq0senbniolessh0';

const reputations = [
  {
    id: 1,
    name: '小明的漫画笔记',
    role: '资深韩漫读者',
    content: '韩漫世界是我每天必刷的网站！下拉式阅读体验真的超级流畅，而且完全免费不用注册，太良心了。收藏夹里已经攒了几十部好看的韩漫作品。',
    rating: 5,
  },
  {
    id: 2,
    name: '漫画控小琳',
    role: '漫画博主',
    content: '作为漫画博主，我经常需要找各种韩漫推荐给粉丝。韩漫世界的分类清晰、更新及时，是我最重要的参考资料之一。强烈推荐给所有韩漫爱好者！',
    rating: 5,
  },
  {
    id: 3,
    name: '二次元爱好者阿杰',
    role: '大学生',
    content: '室友推荐的这个网站，一开始只是随便看看，结果一发不可收拾。现在每天都在追更新，免费韩漫的宝藏网站，必须五星好评！',
    rating: 5,
  },
  {
    id: 4,
    name: '漫游者小雨',
    rating: 5,
    role: '上班族',
    content: '通勤路上的最佳伴侣！在地铁上刷刷韩漫，时间过得飞快。特别喜欢网站的移动端体验，下拉式阅读在手机上太方便了。',
  },
  {
    id: 5,
    name: '书虫小姐',
    rating: 5,
    role: '自由职业者',
    content: '从韩漫小白到深度爱好者，韩漫世界陪伴了我整个入坑过程。网站的分类和推荐系统做得很好，帮我发现了很多冷门但超好看的作品。',
  },
  {
    id: 6,
    name: '宅男日记',
    rating: 5,
    role: '程序员',
    content: 'UI设计简洁大方，加载速度快，没有烦人的广告弹窗。用户体验做得很棒，看得出来网站团队是真心在做产品。推荐给所有漫画爱好者！',
  },
];

export default function AboutPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const payload = new FormData(form);
    const honeypot = (payload.get('website_alt') as string || '').trim();
    if (honeypot !== '') {
      setFormStatus('success');
      setFormData({ name: '', email: '', message: '' });
      return;
    }

    if ((formData.message || '').length > 500) {
      setFormStatus('error');
      setFormError('留言内容不能超过500个字符');
      return;
    }

    try {
      const res = await fetch(CONTACT_FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(
          Array.from(payload.entries()).filter(([k]) => k !== 'website_alt') as [string, string][]
        ).toString(),
      });

      const responseText = await res.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg = parsed?.meta?.message || parsed?.message || '';

      if (res.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormData({ name: '', email: '', message: '' });
      } else {
        setFormStatus('error');
        setFormError(serverMsg || '提交失败，请稍后重试');
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请检查网络连接后重试');
    }
  };

  return (
    <div className="min-h-screen bg-background-50 pt-20">
      <SEO
        title="关于我们 - 韩漫世界"
        description="韩漫世界是一个专注于韩国漫画免费在线阅读的中文平台，提供海量优质韩漫资源，流畅下拉式阅读体验，无需注册即可畅享漫画世界。"
        keywords="韩漫世界,关于我们,韩漫平台介绍,免费漫画网站"
        canonicalUrl="https://www.hanmanworld.com/about"
      />

      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-10">
        <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-10" aria-label="面包屑导航">
          <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap">首页</Link>
          <span>/</span>
          <span className="text-foreground-900 font-medium whitespace-nowrap">关于我们</span>
        </nav>

        <section className="mb-16">
          <div className="flex flex-col lg:flex-row gap-10 items-center">
            <div className="flex-1">
              <h1 className="text-3xl md:text-4xl font-bold font-heading text-foreground-900 mb-4">
                关于韩漫世界
              </h1>
              <p className="text-foreground-600 leading-relaxed mb-4">
                韩漫世界成立于2024年，是一个专注于韩国漫画免费在线阅读的中文平台。我们热爱韩国漫画，致力于为广大中文读者提供最优质的韩漫阅读体验。
              </p>
              <p className="text-foreground-600 leading-relaxed mb-4">
                我们的团队由一群资深的漫画爱好者和技术专家组成。我们深知找到优质、免费的韩漫资源并不容易，因此创建了这个平台，汇聚海量韩漫作品，让每一位读者都能畅享流畅的下拉式阅读体验。
              </p>
              <p className="text-foreground-600 leading-relaxed">
                无需注册、无需付费，打开网页即可阅读。我们坚信好的漫画应该被更多人看到，而阅读的门槛应该尽可能低。韩漫世界，让你随时随地沉浸于漫画的世界。
              </p>
            </div>
            <div className="flex-1">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20illustration%20of%20a%20cozy%20reading%20space%20with%20a%20large%20screen%20displaying%20Korean%20manhwa%20webtoons%2C%20warm%20lighting%2C%20comfortable%20atmosphere%2C%20modern%20minimalist%20interior%2C%20coral%20and%20amber%20accents%2C%20clean%20aesthetic&width=600&height=400&seq=about-banner&orientation=landscape"
                alt="韩漫世界品牌介绍"
                className="w-full rounded-lg object-cover"
                style={{ aspectRatio: '3/2' }}
              />
            </div>
          </div>
        </section>

        <section id="reputation" className="mb-16">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3 text-center">
            用户口碑
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8">
            来自真实用户的好评与反馈
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {reputations.map((item) => (
              <div
                key={item.id}
                className="p-5 rounded-lg bg-background-50 border border-background-200/70"
              >
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: item.rating }).map((_, i) => (
                    <div key={i} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-sm" style={{ color: 'oklch(var(--accent-500))' }}></i>
                    </div>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">{item.content}</p>
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center">
                    <i className="ri-user-line text-secondary-600 text-sm"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{item.name}</p>
                    <p className="text-xs text-foreground-400">{item.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section id="contact" className="max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3 text-center">
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8">
            有任何问题或建议？欢迎给我们留言
          </p>

          <form onSubmit={handleSubmit} data-readdy-form="" id="contact-form" className="flex flex-col gap-4">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                您的称呼
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={(e) => setFormData((prev) => ({ ...prev, name: e.target.value }))}
                required
                className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                placeholder="请输入您的称呼"
              />
            </div>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                电子邮箱
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={(e) => setFormData((prev) => ({ ...prev, email: e.target.value }))}
                required
                className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                placeholder="请输入您的邮箱"
              />
            </div>
            <div>
              <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                留言内容
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={(e) => setFormData((prev) => ({ ...prev, message: e.target.value }))}
                required
                rows={5}
                maxLength={500}
                className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                placeholder="请描述您的问题或建议（500字以内）"
              />
              <p className="text-xs text-foreground-400 mt-1">{formData.message.length}/500</p>
            </div>

            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="form-honeypot"
            />

            {formStatus === 'success' && (
              <div className="p-3 rounded-lg bg-accent-100 text-accent-800 text-sm">
                感谢您的留言！我们会尽快回复您。
              </div>
            )}
            {formStatus === 'error' && (
              <div className="p-3 rounded-lg bg-red-50 text-red-700 text-sm">
                {formError}
              </div>
            )}

            <button
              type="submit"
              className="px-6 py-2.5 text-sm font-medium rounded-full bg-primary-500 text-white whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              发送留言
            </button>
          </form>
        </section>
      </div>
    </div>
  );
}